import React from 'react';
import { layoutMenu } from '../menu';
import Sidebar from "../layouts/SideBar/SideBar";
// import DefaultAside from '../pages/_layout/_asides/DefaultAside';

const asides = [
	{ path: layoutMenu.login.path, element: null, exact: true },
	{ path: '*', element: <Sidebar />, exact: true },
	{ path: 'paperless/meetingList/_details/meetingDetail/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/participants/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/addParticipants/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/annotationRecord/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/fileManagement/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/videoManagement/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/votingManagement/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/votingDetailedManagement/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/votingGroupDetailedManagement/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/votingStatistics/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/voiceSummary/:id', element: null, exact: true },
	{ path: 'PdfPreview/:fileMd5', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/votingGroupManagement/:id', element: null, exact: true, },
	{ path: 'paperless/meetingList/_details/informationManagement/:id', element: null, exact: true, },
	{ path: 'paperless/meetingList/_details/conferenceRecords/:id', element: null, exact: true },
	{ path: 'paperless/meetingList/_details/seatMapArrangement/:id', element: null, exact: true },
];

export default asides;
